module.exports = __webpack_public_path__ + "img/21.7e77da30.jpg";